import { IProductDefinitionList, NodeObjectRepository } from '@/models/assembly';

export const GordionToplanti = {
  'gordion-toplanti': {
    steps: [
      {
        order: 1,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {
          const ayak = repository.get('gordion_top_ayak_en110_arc29_yyy')
            .show()
            .rotate([Math.PI, 1, 0, 0], 1, 'easeOutElastic');

          const kece = repository.get('gordion_kece_yyy')
            .show()
            .rotate([Math.PI, 1, 0, 0], 1, 'easeOutElastic');

          repository.track(ayak, kece);
        },
      },
      {
        order: 2,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const ayak = repository.get('gordion_top_ayak_en110_arc29_yyy')
            .resetRotation([1, 0, 0]);

          const kece = repository.get('gordion_kece_yyy')
            .resetRotation([1, 0, 0]);

          const travers = repository.get('gordion_top_trav_kanal_arc29_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y + 50,
              };
            }, 1.1, 'easeInCubic');

          const vida = repository.get('m6x_22_yhb_civata_cinko_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y - 50,
              };
            }, 1.1, 'easeInCubic');


          travers.show();
          vida.show();
          travers.resetPosition(1.5);
          vida.resetPosition(1.5);
          repository.track(ayak, kece, travers, vida);
        },
      },

      {
        order: 3,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const dik = repository.get('m6_dikdortgen_somn_cnk_yyy')
            .changePosition((x, y, z) => {
              return {
                z: z - 50,
              };
            }, .001, 'easeOutQuad')
            .show()
            .resetPosition(1, 'easeOutQuad');

          repository.track(dik);
        },
      },
      {
        order: 4,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const tas = repository.get('gordion_alm_tasiyici_kol_plsj_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y + 50,
              };
            }, .001, 'easeOutQuad');


          tas.show();

          tas.resetPosition(1, 'easeOutQuad');

          repository.track(tas);
        },
      },
      {
        order: 5,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const vida = repository.get('m6x_25_rysb_civatakafa2_syh_yyy')
            .changePosition((x, y, z) => {
              return {
                x: x - 50,
              };
            }, .001, 'easeOutQuad');

          const vida2 = repository.get('m6x_25_rysb_civatakafa_syh_yyy')
            .changePosition((x, y, z) => {
              return {
                x: x + 50,
              };
            }, .001, 'easeOutQuad');


          vida.show();
          vida2.show();


          vida.resetPosition(1, 'easeOutQuad');
          vida2.resetPosition(1, 'easeOutQuad');

          repository.track(vida, vida2);
        },
      },
      {
        order: 6,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const camT = repository.get('gordion_camtutalm_ikili_plsj_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y + 50,
              };
            }, .001, 'easeOutQuad');

          const vida = repository.get('m6x_12_yhb_civata_cinko_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y + 50,
              };
            }, .001, 'easeOutQuad');

          const tam = repository.get('gordion_genesis_30_aratampon_syh_cnk_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y + 50,
              };
            }, .001, 'easeOutQuad');

          const tam2 = repository.get('gordion_genesis_30_aratampon2_syh_cnk_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y + 50,
              };
            }, .001, 'easeOutQuad');

          camT.show();
          vida.show();
          tam.show();
          tam2.show();


          camT.resetPosition(1, 'easeOutQuad');
          vida.resetPosition(1, 'easeOutQuad');
          tam.resetPosition(1, 'easeOutQuad');
          tam2.resetPosition(1, 'easeOutQuad');

          repository.track(camT, vida, tam);
        },
      },
      {
        order:7,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const traversKapak = repository.get('gordion_trv_yankap_top_plsj_yyy')
            .changePosition((x, y, z) => {
              return {
                z: z + 50,
              };
            }, .001, 'easeOutQuad');


          const traversKapak2 = repository.get('gordion_trv_yankap2_top_plsj_yyy')
            .changePosition((x, y, z) => {
              return {
                z: z - 50,
              };
            }, .001, 'easeOutQuad');

          const vida = repository.get('m6x_10_setskur_civata_syh_yyy')
            .changePosition((x, y, z) => {
              return {
                x: x + 50,
              };
            }, .001, 'easeOutQuad');

          const vida3 = repository.get('m6x_10_setskur_civata2_syh_yyy')
            .changePosition((x, y, z) => {
              return {
                x: x - 50,
              };
            }, .001, 'easeOutQuad');


          traversKapak.show();
          traversKapak2.show();
          vida.show();
          vida3.show();


          traversKapak.resetPosition(1, 'easeOutQuad');
          traversKapak2.resetPosition(1, 'easeOutQuad');
          vida.resetPosition(1, 'easeOutQuad');

          vida3.resetPosition(1, 'easeOutQuad');

          repository.track(traversKapak, vida, vida3,traversKapak2);
        },
      },
      {
        order: 8,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const tab = repository.get('gordion_comp_tap_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y + 50,
              };
            }, .001, 'easeOutQuad');

          const civata = repository.get('m6x_25_ysb_civata_yiyah_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y - 50,
              };
            }, .001, 'easeOutQuad');

          const civataCinko = repository.get('m6x_22_yhb_civata_cinko2_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y - 50,
              };
            }, .001, 'easeOutQuad');


          tab.show();
          civata.show();
          civataCinko.show();

          tab.resetPosition(1, 'easeOutQuad');
          civata.resetPosition(1, 'easeOutQuad');
          civataCinko.resetPosition(1, 'easeOutQuad');

          repository.track(tab, civata, civataCinko);
        },
      },
      {
        order: 9,
        desc:'',
        apply: (repository: NodeObjectRepository): void => {

          const tab = repository.get('gordion_flansli_cam_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y + 50,
              };
            }, .001, 'easeOutQuad');

          const civata = repository.get('m6x_12_yhb_civata_cinko2_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y - 50,
              };
            }, .001, 'easeOutQuad');

          const civataCinko = repository.get('m6x_12_ysb_civata_cinko_yyy')
            .changePosition((x, y, z) => {
              return {
                y: y - 50,
              };
            }, .001, 'easeOutQuad');


          tab.show();
          civata.show();
          civataCinko.show();

          tab.resetPosition(1, 'easeOutQuad');
          civata.resetPosition(1, 'easeOutQuad');
          civataCinko.resetPosition(1, 'easeOutQuad');

          repository.track(tab, civata, civataCinko);
        },
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/models/assembly/defs/gordion-toplanti.ts